import React from 'react';
import { Navigate } from 'react-router-dom';

import {
  DASHBOARD_PAGE,
  ERROR_PAGE,
  EXTRA_PAGE,
  FOR_NURSES_PAGE,
  FOR_PARTNERS_PAGE,
  HOME_PAGE,
  MY_PROFILE_PAGE,
  RESET_PASSWORD_PAGE,
  VIDEO_PAGE,
  TRAINING_PAGE,
  OLD_TRAINING_PAGE,
  VIDEO_PAGE_EXPERT_TALKS,
  COACHING_LESSONS_PAGE,
  COACHING_PAGE,
  COACHING_DETAIL_PAGE,
  COACHING_MODULE_PAGE,
  COACHING_MODULE_DETAILS_PAGE,
  COACHING_PAYMENT_FIRST_STEP,
  COACHING_PAYMENT_SECOND_STEP,
  COACHING_PAYMENT_THIRD_STEP,
  COACHING_PAYMENT_FOURTH_STEP,
  REGISTRATION_CONFIRMATION_PAGE,
  REGISTRATION_CONFIRMED_PAGE,
  QUIZ_PAGE,
  NEWSLETTER_CONFIRM_PAGE,
  NEWSLETTER_CONFIRMED_PAGE,
  MODULE_PAYMENT_FIRST_STEP,
  MODULE_PAYMENT_SECOND_STEP,
  MODULE_PAYMENT_THIRD_STEP,
  MODULE_PAYMENT_FOURTH_STEP,
  FULL_CONTACT_PAGE,
  COACHING_MODULE_ENDED_PAGE,
  CLIPS_PAGE,
  CLIPS_LESSONS_PAGE,
  CLIPS_MODULE_PAGE,
  CLIPS_MODULE_DETAILS_PAGE,
  CLIPS_MODULE_ENDED_PAGE,
  CLIPS_DETAIL_PAGE,
  TYPER_PAGE,
  PARTNERS_PAGE,
  PARTNER_PAGE_SINGULAR,
  PARTNERS_PAGE_REDIRECT,
  REGISTER_PAGE,
  REGISTER_PAGE_CODE,
  TYPER_DETAIL_PAGE,
  TYPER_LESSONS_PAGE,
  TYPER_MODULE_DETAILS_PAGE,
  TYPER_MODULE_ENDED_PAGE,
  TYPER_MODULE_PAGE,
  OLD_ONCO_COACH_2025,
  ONCO_COACH_PRESENTATION_PAGE,
} from 'constants/routes';
import PrivateRoute from './components/PrivateRoute';
import DashboardPage from './components/pages/DashboardPage';
import ProfilePage from './components/pages/ProfilePage';
import ForNursesPage from './components/pages/ForNursesPage';
import ErrorPage from './components/pages/ErrorPage';
import HomePage from './components/pages/HomePage';
import TrainingPage from './components/pages/TrainingPage';
import PartnersPage from './components/pages/PartnersPage';
import VideoPage from './components/pages/VideoPage';
import ForPartnersPage from './components/pages/ForPartnersPage';
import ResetPasswordPage from './components/pages/ResetPasswordPage';
import ExtraPage from './components/pages/ExtraPage';
import PublicRoute from './components/PublicRoute';
import CoachingPage from './components/pages/CoachingPage';
import CoachingModulePage from './components/pages/CoachingModulePage';
import CoachingLessonPage from './components/pages/CoachingLessonPage';
import CoachingPaymentFirstPage from './components/pages/CoachingPaymentFirstPage';
import CoachingDetailsPage from './components/pages/CoachingDetailsPage';
import CoachingPaymentSecondPage from './components/pages/CoachingPaymentSecondPage';
import CoachingPaymentThirdPage from './components/pages/CoachingPaymentThirdPage';
import CoachingPaymentFourthPage from './components/pages/CoachingPaymentFourthPage';
import ClipsPage from './components/pages/clips/ClipsPage';
import RegisterPage from './components/pages/RegisterPage';
import RegistrationConfirmPage from './components/pages/RegistrationConfirmPage';
import RegistrationConfirmedPage from './components/pages/RegistrationConfirmedPage';
import QuizPage from './components/pages/QuizPage';
import NewsletterConfirmPage from './components/pages/NewsletterConfirmPage';
import NewsletterConfirmedPage from './components/pages/NewsletterConfirmedPage';
import PartnerDetailPage from './components/pages/PartnerDetailPage';
import ContactPage from './components/pages/ContactPage';
import CoachingModuleEnded from './components/pages/coachings/CoachingModuleEnded';
import TyperPage from './components/pages/TyperPage';
import { OncoCoachStatic } from './components/pages/OncoCoachStatic';
import AppLayout from './components/layout/AppLayout';

export const routes = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        path: ERROR_PAGE,
        element: <ErrorPage />,
      },
      {
        path: EXTRA_PAGE,
        element: <ExtraPage />,
      },
      {
        path: NEWSLETTER_CONFIRM_PAGE,
        element: <NewsletterConfirmPage />,
      },
      {
        path: NEWSLETTER_CONFIRMED_PAGE,
        element: <NewsletterConfirmedPage />,
      },
      {
        path: REGISTER_PAGE,
        element: <RegisterPage />,
      },
      {
        path: REGISTER_PAGE_CODE,
        element: <RegisterPage />,
      },
      {
        path: FOR_NURSES_PAGE,
        element: (
          <PublicRoute>
            <ForNursesPage />
          </PublicRoute>
        ),
      },
      {
        path: FOR_PARTNERS_PAGE,
        element: (
          <PublicRoute>
            <ForPartnersPage />
          </PublicRoute>
        ),
      },
      {
        path: RESET_PASSWORD_PAGE,
        element: (
          <PublicRoute>
            <ResetPasswordPage />
          </PublicRoute>
        ),
      },
      {
        path: HOME_PAGE,
        element: <HomePage />,
      },
      {
        path: REGISTRATION_CONFIRMATION_PAGE,
        element: (
          <PublicRoute>
            <RegistrationConfirmPage />
          </PublicRoute>
        ),
      },
      {
        path: REGISTRATION_CONFIRMED_PAGE,
        element: (
          <PublicRoute>
            <RegistrationConfirmedPage />
          </PublicRoute>
        ),
      },
      {
        path: DASHBOARD_PAGE,
        element: (
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        ),
      },
      {
        path: VIDEO_PAGE,
        element: (
          <PrivateRoute redirectRoute={TRAINING_PAGE}>
            <VideoPage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_LESSONS_PAGE,
        element: (
          <PrivateRoute>
            <CoachingLessonPage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_MODULE_PAGE,
        element: (
          <PrivateRoute>
            <CoachingModulePage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_MODULE_DETAILS_PAGE,
        element: (
          <PrivateRoute>
            <CoachingModulePage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_MODULE_ENDED_PAGE,
        element: (
          <PrivateRoute>
            <CoachingModuleEnded />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_DETAIL_PAGE,
        element: <CoachingDetailsPage />,
      },
      {
        path: COACHING_PAYMENT_FIRST_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentFirstPage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_PAYMENT_SECOND_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentSecondPage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_PAYMENT_THIRD_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentThirdPage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_PAYMENT_FOURTH_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentFourthPage />
          </PrivateRoute>
        ),
      },
      {
        path: MODULE_PAYMENT_FIRST_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentFirstPage />
          </PrivateRoute>
        ),
      },
      {
        path: MODULE_PAYMENT_SECOND_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentSecondPage />
          </PrivateRoute>
        ),
      },
      {
        path: MODULE_PAYMENT_THIRD_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentThirdPage />
          </PrivateRoute>
        ),
      },
      {
        path: MODULE_PAYMENT_FOURTH_STEP,
        element: (
          <PrivateRoute>
            <CoachingPaymentFourthPage />
          </PrivateRoute>
        ),
      },
      {
        path: COACHING_PAGE,
        element: <CoachingPage />,
      },
      {
        path: CLIPS_LESSONS_PAGE,
        element: (
          <PrivateRoute type={'clips'}>
            <CoachingLessonPage />
          </PrivateRoute>
        ),
      },
      {
        path: CLIPS_MODULE_PAGE,
        element: (
          <PrivateRoute type={'clips'}>
            <CoachingModulePage />
          </PrivateRoute>
        ),
      },
      {
        path: CLIPS_MODULE_DETAILS_PAGE,
        element: (
          <PrivateRoute type={'clips'}>
            <CoachingModulePage />
          </PrivateRoute>
        ),
      },
      {
        path: CLIPS_MODULE_ENDED_PAGE,
        element: (
          <PrivateRoute type={'clips'}>
            <CoachingModuleEnded />
          </PrivateRoute>
        ),
      },
      {
        path: CLIPS_DETAIL_PAGE,
        element: <CoachingDetailsPage type={'clips'} />,
      },
      {
        path: CLIPS_PAGE,
        element: <ClipsPage />,
      },
      {
        path: TYPER_LESSONS_PAGE,
        element: (
          <PrivateRoute type={'typer'}>
            <CoachingLessonPage />
          </PrivateRoute>
        ),
      },
      {
        path: TYPER_MODULE_PAGE,
        element: (
          <PrivateRoute type={'typer'}>
            <CoachingModulePage />
          </PrivateRoute>
        ),
      },
      {
        path: TYPER_MODULE_DETAILS_PAGE,
        element: (
          <PrivateRoute type={'typer'}>
            <CoachingModulePage />
          </PrivateRoute>
        ),
      },
      {
        path: TYPER_MODULE_ENDED_PAGE,
        element: (
          <PrivateRoute type={'typer'}>
            <CoachingModuleEnded />
          </PrivateRoute>
        ),
      },
      {
        path: TYPER_PAGE,
        element: <TyperPage />,
      },
      {
        path: TYPER_DETAIL_PAGE,
        element: <CoachingDetailsPage type={'clips'} />,
      },
      {
        path: QUIZ_PAGE,
        element: (
          <PrivateRoute>
            <QuizPage />
          </PrivateRoute>
        ),
      },
      {
        path: VIDEO_PAGE_EXPERT_TALKS,
        element: (
          <PrivateRoute redirectRoute={TRAINING_PAGE}>
            <VideoPage />
          </PrivateRoute>
        ),
      },
      {
        path: TRAINING_PAGE,
        element: <TrainingPage />,
      },
      {
        path: OLD_TRAINING_PAGE,
        element: <Navigate to={TRAINING_PAGE} replace />,
      },
      {
        path: MY_PROFILE_PAGE,
        element: (
          <PrivateRoute>
            <ProfilePage />
          </PrivateRoute>
        ),
      },
      {
        path: PARTNERS_PAGE_REDIRECT,
        element: <Navigate to={PARTNERS_PAGE} replace />,
      },
      {
        path: PARTNERS_PAGE,
        element: <PartnersPage />,
      },
      {
        path: PARTNER_PAGE_SINGULAR,
        element: <PartnerDetailPage />,
      },
      {
        path: FULL_CONTACT_PAGE,
        element: <ContactPage />,
      },
      {
        path: ONCO_COACH_PRESENTATION_PAGE,
        element: <OncoCoachStatic />,
      },
      {
        path: OLD_ONCO_COACH_2025,
        element: <Navigate to={ONCO_COACH_PRESENTATION_PAGE} replace />,
      },
      {
        path: '*',
        element: <Navigate to={ERROR_PAGE} replace />,
      },
    ],
  },
];

